import { ColumnKeys, OS, RawEventConfigGridItem } from '../types';

const osIconClasses = {
  [OS.WINDOWS]: `icon-windows`,
  [OS.LINUX]: `icon-linux`,
  [OS.MAC]: `icon-apple`,
};

function renderOsIcon(os: OS) {
  return `<span class="icon ` + osIconClasses[os] + `" part='raw-event-os-icon'></span>`;
}

export function osListRenderer({ item }: { item: RawEventConfigGridItem }): HTMLElement {
  const cell = document.createElement('div');

  cell.innerHTML = item[ColumnKeys.OS_TYPES].map(os => renderOsIcon(os)).join('');
  return cell;
}
